import React, { useState, useMemo, useEffect, useRef } from "react";
import { MDBIcon, MDBLoadingManagement, MDBTooltip } from "mdb-react-ui-kit";
import CommonViewLayout from "./CommonViewLayout";
import UserAction from "../CommonViewComponents/UserAction";
import usePermissionForPages from "../../../Hooks/usePermissionForPages";
import DataTable from "../../../Components/DatatableFrontEnd/DataTable";
import MerlinModal from "../Merlin/MerlinModal";
import useAxiosCall from "../../../Hooks/useAxiosCall";
import { useLoadingOverlay } from "../../../Context/LoadingOverlayContext";
import { decryptData, encryptData } from "../../../Utilities/CryptoUtility";
import UploadFile from "./UploadFile";
import { SecureStorage } from "../../../Utilities/StorageEncryption";
const UserUpload = () => {
  const [data, setData] = useState({ columns: [], rows: [] });
  const basicRef = useRef(null);
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const { isVisible } = useLoadingOverlay();
  let isMainLoaderVisible = isVisible;
  usePermissionForPages(['VendorPortal'], '/administrator/users');
  const [tableState, setTableState] = useState({
    pageNumber: 1,
    pageSize: 10,//move to env
    sortColumn: '',
    sortDirection: '',
    searchValues:[],
  });
  useEffect(() => {
    getUploadData();
  }, []);

  const handleApiCallSuccess = (encryptedData) => {
    let data = decryptData(encryptedData.data);
    data = data.files;
    const transformedColumns = [
      {
        caption: "Actions",
        defaultValue: null,
        fieldName: "actions",
        fieldType: null,
        filterType: null,
        filterValues: null,
        sortable: false,
        visible: "Yes"
      },
      ...data.columns
    ];
    const transformedRows = data.rows.map((detail, i) => {
      let actionParams = {'filename' : detail.fileName, 'fileExtension' : detail.fileType};
      return {
        ...detail,
        actions: <UserAction index={i} filename={detail.fileName} portal="userupload" actionParams={actionParams} getUploadData= {getUploadData}/>,
      }
    });
    setData({ columns: transformedColumns, rows: transformedRows, totalRecords: data.totalRecords });
    let columnsData = transformedColumns.map((item) => {
      return item.fieldName;
    })
    setSelectedColumns(columnsData)
    const visibleColumns = transformedColumns.filter(column => column.visible === "Yes");
    setMerlinColumns(visibleColumns)
  };

  const handleApiCallError = (errorMessage) => {
    console.log(errorMessage);
  };

  const { makeApiCall } = useAxiosCall();

  const getUploadData = async () => {
    const requestData = {
      data: encryptData(JSON.stringify(
        {
          page: tableState.pageNumber,
          pageSize: tableState.pageSize,
          sortColumn: tableState.sortColumn,
          sortDirection: tableState.sortDirection,
          searchValues: tableState.searchValues,
          domain: SecureStorage.getItem('domain'),
        }
      ))
    };

    let isRequestCancelled = false;

    try {
      setIsLoaderOpen(true);
      await makeApiCall({
        requestData,
        onSuccess: handleApiCallSuccess,
        onError: handleApiCallError,
        requestType: 'GET',
        url: 'uploadsListing',
        loader: false
      });
    } catch (error) {
      if (error.message == 'Request canceled') {
        isRequestCancelled = true;
      } else {
        console.error('API call error:', error);
      }
    } finally {
      if (!isRequestCancelled) {
        setIsLoaderOpen(false)
      }
    }
  };

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [merlinColumns, setMerlinColumns] = useState([]);

  const [isMerlinModalOpen, setIsMerlinModalOpen] = useState(false);
  const [isFileUploadModelOpen, setIsFileUploadModelOpen] = useState(false);

  const openMerlinModal = () => {
    setIsMerlinModalOpen(true);
  };
  const openFileUploadModal = () => {
    setIsFileUploadModelOpen(true);
  };

  const closeMerlinModal = () => {
    setIsMerlinModalOpen(false);
  };
  const closeFileUploadModal = () => {
    setIsFileUploadModelOpen(false);
  };

  const ProspectFilters = useMemo(() => (
    <div className="d-flex align-items-center" style={{ flexWrap: 'wrap' }}>
      <div style={{ minWidth: 'max-content', cursor: 'pointer', marginRight:'18px' }} onClick={openFileUploadModal}>
        <MDBTooltip tag='span' wrapperProps={{ color: 'secondary' }} title="Add File">
          <MDBIcon fas icon="add" style={{  }} />
        </MDBTooltip>
      </div>
      {/* <div style={{ minWidth: 'max-content' }}>
        <ExportDropdown noMargin portalType={'prospect'} filters={tableState} label="Prospect" />
      </div> */}
      <div style={{ minWidth: 'max-content', cursor: 'pointer' }} onClick={openMerlinModal}>
        <MDBTooltip tag='span' wrapperProps={{ color: 'secondary' }} title="Settings">
          <MDBIcon fas icon="cogs" style={{  }} />
        </MDBTooltip>
      </div>
    </div>
  ), [tableState]);

  const handleSort = (column, direction) => {
    setTableState((prev) => ({
      ...prev,
      pageNumber: 1,
      sortColumn: column,
      sortDirection: direction,
    }));
  };

  const handleSearch = (searchValues) => {
    setTableState((prev) => ({
      ...prev,
      pageNumber: 1,
      searchValues,
    }));
  };


  const handlePageChange = (pageNumber) => {
    setTableState((prev) => ({
      ...prev,
      pageNumber,
    }));
  };
  const handleRowsPerPageChange = (size) => {
    setTableState((prev) => ({
      ...prev,
      pageSize : size,
    }));
  };

  return (
    <CommonViewLayout
      headerTitle="User Upload"
      filters={ProspectFilters}
      iconName="file-upload"
      isReport={true}
    >
      <DataTable
        data={data}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        onSort={handleSort}
        onSearch={handleSearch}
        portal={'userupload'}
        search={false}
      />
      {isMerlinModalOpen && (
        <MerlinModal
          isOpen={isMerlinModalOpen}
          onClose={closeMerlinModal}
          columns={merlinColumns}
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
          portal={'userupload'}
        />
      )}
      {isFileUploadModelOpen && (
        <UploadFile
          isOpen={isFileUploadModelOpen}
          onClose={closeFileUploadModal}
          getUploadData={getUploadData}
        />
      )}
      {(isLoaderOpen && isMainLoaderVisible != true) &&
        <MDBLoadingManagement parentRef={basicRef} backdrop={false} loadingText="" backdropOpacity={0} />
      }
    </CommonViewLayout>
  );
};

export default UserUpload;
